import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
  FaStore,
} from 'react-icons/fa';
import './Footer.css';
import bcLogo from '../../media/BC.png';

function Footer() {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const openInstagram = (e) => {
    e.preventDefault();
    const url = 'https://www.instagram.com/blockclubstl/';

    const isStandalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    if (isStandalone) {
      window.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <footer className="app-footer" aria-label="Block Club footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <img
              src={bcLogo}
              alt="Block Club"
              className="footer-logo"
            />
            <h2 className="footer-brand-name">Block Club</h2>
            <p className="footer-brand-tagline">
              Your Community, Your Discounts
            </p>
          </div>

          {/* Follow Us Section */}
          <div className="footer-section">
            <h3 className="footer-section-title">{t('footer.followUs')}</h3>
            <div className="footer-social-links">
              <a
                href="https://www.instagram.com/blockclubstl/"
                onClick={openInstagram}
                className="footer-social-link"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/blockclubstl"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.tiktok.com/@blockclubstl"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="TikTok"
              >
                <FaTiktok />
              </a>
              <a
                href="https://www.linkedin.com/company/blockclubstl/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Contact Us Section */}
          <div className="footer-section">
            <h3 className="footer-section-title">{t('footer.contactUs')}</h3>
            <ul className="footer-list">
              <li>
                <a href="mailto:support@joinblockclub.com" className="footer-link">
                  <FaEnvelope className="footer-link-icon" />
                  {t('footer.email')}
                </a>
              </li>
            </ul>
          </div>

          {/* Partnership Section */}
          <div className="footer-section footer-partner">
            <h3 className="footer-section-title">{t('footer.partnerWithUs')}</h3>
            <p className="footer-partner-description">
              {t('footer.partnerDescription')}
            </p>
            <button
              className="footer-partner-btn"
              onClick={() => navigate('/become-partner')}
            >
              <FaStore />
              {t('footer.partnerButton')}
            </button>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <span>© {year} {t('footer.copyright')}</span>
          </div>
          <div className="footer-legal">
            <a href="/privacy" className="footer-legal-link">
              {t('footer.privacyPolicy')}
            </a>
            <span className="footer-divider">•</span>
            <a href="/terms" className="footer-legal-link">
              {t('footer.termsOfService')}
            </a>
            <span className="footer-divider">•</span>
            <a href="/cookies" className="footer-legal-link">
              {t('footer.cookiePolicy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
